import { createTheme } from "@mui/material/styles";

// MUI Theme に Sidebar 用の独自カラートークンを追加するための module augmentation。
// PRESTIGE 指定の紫 (#28233B) をベースにしたサイドバーのトーン。
declare module "@mui/material/styles" {
  interface Palette {
    sidebar: SidebarPalette;
    errorState: ErrorStatePalette;
  }
  interface PaletteOptions {
    sidebar?: SidebarPalette;
    errorState?: ErrorStatePalette;
  }
}

export interface SidebarPalette {
  background: string;
  hoverBackground: string;
  activeBackground: string;
  divider: string;
  sectionText: string;
  itemText: string;
  itemTextMuted: string;
}

const sidebar: SidebarPalette = {
  background: "#28233B",
  hoverBackground: "#383350",
  activeBackground: "#423C5E",
  divider: "#423C5E",
  sectionText: "#AA9B82",
  itemText: "#FFFFFF",
  itemTextMuted: "rgba(255, 255, 255, 0.6)",
};

// ErrorStateView (error-boundary) の配色。severity ごとの円形アイコンの背景色と、見出し・説明文の色。
// palette.error / warning / text を直接使うと、アプリ側で合わせるために上書きした際に
// Alert や Typography 全体の色まで変わってしまうため、専用のトークンとして分ける。
export interface ErrorStatePalette {
  error: string;
  warning: string;
  info: string;
  title: string;
  body: string;
}

// 既定値は MUI 標準の error.main / warning.main / text.secondary / text.primary 相当。
const errorState: ErrorStatePalette = {
  error: "#d32f2f",
  warning: "#ed6c02",
  info: "rgba(0, 0, 0, 0.6)",
  title: "rgba(0, 0, 0, 0.87)",
  body: "rgba(0, 0, 0, 0.87)",
};

// Viajero フロントエンド共通の MUI テーマ。
// MUI コンポーネントのスタイルは components.<MuiXxx>.styleOverrides で上書きする。
// アプリ側でさらに上書きしたい場合は createTheme(defaultTheme, { ... }) で extend する。
export const defaultTheme = createTheme({
  palette: {
    // ブランド色。`color="primary"` を指定した MUI コンポーネントに反映される
    primary: {
      main: "#9C8262",
    },
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF",
    },
    divider: "#D8D8D8",
    sidebar,
    errorState,
  },
  typography: {
    // アプリ全体の本文フォントサイズのデフォルトを 14px に統一
    fontSize: 14,
    body1: { fontSize: 14 },
    body2: { fontSize: 14 },
    button: { fontSize: 14 },
  },
  components: {
    // 更新通知 Snackbar (UpdateSnackbar) の見た目を制御する箇所
    // minWidth はここでは指定しない (全 Alert に効いてしまい、他画面のポップアップ内で
    // 横スクロールを引き起こすため)。UpdateSnackbar 側の sx で個別に指定する。
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: 14,
          // severity="info" + variant="filled" の組み合わせ時の背景色
          // MUI v9 で filledInfo キーは廃止され、CSS セレクタで指定する形に変更
          "&.MuiAlert-filled.MuiAlert-colorInfo": {
            backgroundColor: "#323232",
          },
        },
      },
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          fontSize: 16,
          fontWeight: 700,
          marginBottom: 4,
        },
      },
    },
  },
});
